import { ObjectSchema, ValidationResult, ArraySchema } from 'joi';
import { IPlainObject } from '../models';

interface ValidateJoiResultModel<T> extends ValidationResult {
  formikErrors: T;
}

export function validateFormikWithJoi<T>(
  schema: ObjectSchema<T> | ArraySchema,
  values: IPlainObject,
  skipErrorKey?: string,
): Partial<ValidateJoiResultModel<T>> {
  const validateResult = schema.validate(values, {
    abortEarly: false,
    stripUnknown: true,
  });
  const defaultResult = { formikErrors: {} as T };

  if (!validateResult || !validateResult.error) {
    return defaultResult;
  }

  const formikErrors = validateResult.error.details.reduce<T>(
    (acum, { path, message }) => {
      const key = skipErrorKey
        ? path.join('.').replace(`${skipErrorKey}.`, '')
        : path.join('.');

      return {
        ...acum,
        [key]: message,
      };
    },
    {} as T,
  );

  return {
    ...validateResult,
    formikErrors,
  };
}
